import * as React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Skeleton } from '@/components/ui/skeleton';
import { getTikhubConfig, saveTikhubConfig } from '@/api/client';

export function TikhubConfigTab() {
  const [apiKey, setApiKey] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  const [saving, setSaving] = React.useState(false);
  const [saveMsg, setSaveMsg] = React.useState('');

  const load = React.useCallback(async () => {
    setLoading(true);
    setSaveMsg('');
    try {
      const data = await getTikhubConfig();
      setApiKey(data.config?.api_key || '');
    } catch {
      /* ignore */
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => { load(); }, [load]);

  const handleSave = React.useCallback(async () => {
    setSaving(true);
    setSaveMsg('');
    try {
      await saveTikhubConfig({ tikhub: { api_key: apiKey.trim() } });
      setSaveMsg('已保存');
      setTimeout(() => setSaveMsg(''), 2000);
    } catch (err) {
      setSaveMsg(err instanceof Error ? err.message : '保存失败');
    } finally {
      setSaving(false);
    }
  }, [apiKey]);

  if (loading) {
    return <Skeleton className="h-48 w-full rounded-xl" />;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>TikHub API 配置</CardTitle>
        <CardDescription>配置社媒监控所需的 TikHub API Key，用于抖音 / 小红书 / 视频号账号数据拉取</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <label className="mb-1 block text-sm font-medium">API Key</label>
          <Input
            type="password"
            className="h-8 text-sm"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            placeholder="输入 TikHub API Key"
          />
          <p className="mt-1.5 text-xs text-muted-foreground">
            保存后，社媒监控中的账号信息拉取会自动使用该 Key。留空则回退到环境变量。
          </p>
        </div>

        <div className="flex items-center gap-3">
          <Button onClick={handleSave} disabled={saving}>
            {saving ? '保存中…' : '保存配置'}
          </Button>
          {saveMsg && (
            <span className={`text-sm ${saveMsg === '已保存' ? 'text-emerald-500' : 'text-destructive'}`}>
              {saveMsg}
            </span>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
